'use client';

import dynamic from 'next/dynamic';

export const RaindowButtonDemo = dynamic(
  () => import('./ButtonDemo')
);
